import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

// protectedroutes for HR/Admin
const useAuthforHr = () => {
  const role = localStorage.getItem('role')
  if (role === 'HR' || role === 'Admin') {
    return true
  } else {
    return false
  }
}

export const ProtectedRoutesHR = ({ component: Component, ...restOfProps }) => {
  const auth = useAuthforHr()

  return auth ? <Outlet /> : <Navigate to="/" />
}

// protectedroutes for HR/Admin and interviewer
const useAuthforHrInterviewer = () => {
  const role = localStorage.getItem('role')
  if (role === 'HR' || role === 'Admin' || role === 'Interviewer') {
    return true
  } else {
    return false
  }
}

export const ProtectedRoutesHRInterviewer = ({
  component: Component,
  ...restOfProps
}) => {
  const auth = useAuthforHrInterviewer()

  return auth ? <Outlet /> : <Navigate to="/" />
}

// general protected routes
const useAuth = () => {
  const user = localStorage.getItem('user')
  if (user) {
    return true
  } else {
    return false
  }
}

export const ProtectedRoutes = ({ component: Component, ...restOfProps }) => {
  const auth = useAuth()

  return auth ? <Outlet /> : <Navigate to="/" />
}

// protected routes for interviewer
const useAuthforInterviewer = () => {
  const role = localStorage.getItem('role')
  if (role === 'Interviewer') {
    return true
  } else {
    return false
  }
}

export const ProtectedRoutesInterviewer = ({
  component: Component,
  ...restOfProps
}) => {
  const auth = useAuthforInterviewer()

  return auth ? <Outlet /> : <Navigate to="/" />
}

// protected routes for employee
const useAuthforEmployee = () => {
  const role = localStorage.getItem('role')
  if (role === 'Employee' || role === 'Interviewer') {
    return true
  } else {
    return false
  }
}

export const ProtectedRoutesEmployee = ({
  component: Component,
  ...restOfProps
}) => {
  const auth = useAuthforEmployee()

  return auth ? <Outlet /> : <Navigate to="/" />
}

// protectedroutes for HR/Admin and EMployee
const useAuthforHrEmployee = () => {
  const role = localStorage.getItem('role')
  if (role === 'HR' || role === 'Admin' || role === 'Employee') {
    return true
  } else {
    return false
  }
}

export const ProtectedRoutesHREmployee = ({
  component: Component,
  ...restOfProps
}) => {
  const auth = useAuthforHrEmployee()

  return auth ? <Outlet /> : <Navigate to="/" />
}
